import { render, staticRenderFns } from "./v-header-box.vue?vue&type=template&id=a6267e62&scoped=true"
import script from "./v-header-box.vue?vue&type=script&lang=js"
export * from "./v-header-box.vue?vue&type=script&lang=js"
import style0 from "./v-header-box.vue?vue&type=style&index=0&id=a6267e62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6267e62",
  null
  
)

export default component.exports